// extracted by mini-css-extract-plugin
module.exports =  {"statusCard":"statusCard_FaDiIC5v"};